module.exports = __webpack_public_path__ + "static/media/picJaqu.43daf005.png";